/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["mni-Beng",[["নুমাং","PM"],u,["এ এম","পি এম"]],[["নুমাং","PM"]],[["নোং","নিং","লৈবা","য়ুম","শগো","ইরা","থাং"],["নোংমাইজিং","নিংথৌকাবা","লৈবাকপোকপা","য়ুমশকৈশা","শগোলশেন","ইরাই","থাংজ"]],[["নো","নিং","লৈ","য়ুম","শগ","ইরা","থাং"],["নোংমাইজিং","নিংথৌকাবা","লৈবাকপোকপা","য়ুমশকৈশা","শগোলশেন","ইরাই","থাংজ"]],[["জা","ফে","মার","এপ","মে","জুন","জুল","আ","সে","ওক","নব","ডি"],["জানুৱারি","ফেব্রুৱারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেম্বর","ওক্টোবর","নভেম্বর","ডিসেম্বর"]],[["জা","ফে","মার","এপ","মে","জুন","জুল","আ","সে","ও","নব","ডি"],["জানু","ফেব্রু","মার","এপ্রি","মে","জুন","জুলা","আগ","সেপ্ট","ওক্টো","নভে","ডিসে"],["জানুৱারি","ফেব্রুৱারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","ওগষ্ট","সেপ্টেম্বর","ওক্টোবর","নবেম্বর","ডিসেম্বর"]],[["খৃ: মমাং","খৃ: মতুং"]],0,[0,0],["d/M/yy","MMM d, y","MMMM d, y","MMMM d, y, EEEE"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,"{1} গী {0} দা",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"INR","₹","ইন্দিয়ান রুপী",{"JPY":["JP¥","¥"]},"ltr", plural];
